import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, ErrorHandler, isDevMode, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MyInterceptor } from './shared/interceptors/my-interceptor';
import { GlobalErrorHandler } from './shared/services/global-error-handler';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerLocalizationService, I18n } from './shared/services/datepicker-localization.service';
import { provideDaterangepickerLocale } from 'ngx-daterangepicker-bootstrap';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { providePrimeNG } from 'primeng/config';

import Aura from '@primeuix/themes/aura';

const applyBootstrapTheme = () => {
  const root = document.documentElement;
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const theme = prefersDark ? 'dark' : 'light';

  root.setAttribute('data-bs-theme', theme);
  root.style.colorScheme = theme;
};

applyBootstrapTheme();

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled', // Enforces scrolling to #id
        scrollPositionRestoration: 'enabled' // Optional: Restores scroll position on back button
      })),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideBrowserGlobalErrorListeners(),
    //provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      translation: {
        startsWith: 'Comienza con',
        contains: 'Contiene',
        notContains: 'No contiene',
        endsWith: 'Termina con',
        equals: 'Igual a',
        notEquals: 'Diferente de',
        noFilter: 'Sin filtro',
        lt: 'Menor que',
        lte: 'Menor o igual que',
        gt: 'Mayor que',
        gte: 'Mayor o igual que',
        dateIs: 'Fecha es',
        dateIsNot: 'Fecha no es',
        dateBefore: 'Fecha antes de',
        dateAfter: 'Fecha después de',
        clear: 'Limpiar',
        apply: 'Aplicar',
        matchAll: 'Coincidir todo',
        matchAny: 'Coincidir cualquiera',
        addRule: 'Agregar regla',
        removeRule: 'Eliminar regla',
        accept: 'Sí',
        reject: 'No',
        choose: 'Elegir',
        upload: 'Subir',
        cancel: 'Cancelar',
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        today: 'Hoy',
        weekHeader: 'Sm',
        firstDayOfWeek: 1,
        dateFormat: 'dd/mm/yy',
        weak: 'Débil',
        medium: 'Medio',
        strong: 'Fuerte',
        after: 'Después',
        before: 'Antes',
      },
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: 'system',
          cssLayer: true,
        },
      },
    }),
    provideDaterangepickerLocale({
      separator: ' - ',
      applyLabel: 'OK',
      clearLabel: 'Limpiar',
      daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    }),
    provideCharts(withDefaultRegisterables()),
    { provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true },
    I18n,
    { provide: NgbDatepickerI18n, useClass: DatepickerLocalizationService },
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.pwa,
      //registrationStrategy: 'registerWhenStable:30000',
      registrationStrategy: 'registerImmediately',

    }),
    provideAppInitializer(async () => {
      applyBootstrapTheme();

      if (environment.pwa) {
        const networkService = inject(NetworkService);
        await networkService.updateOnlineStatus();
      }

      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      mediaQuery.addEventListener?.('change', applyBootstrapTheme);
    })
  ],
};
console.log('devmode', isDevMode());
console.log('environment.pwa', environment.pwa);
navigator.serviceWorker.ready.then(function (swRegistration) {

  console.log('swReady');
});
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NetworkService } from './shared/services/network-service.service';

Chart.register(ChartDataLabels);
